import { enumValidator } from '#validation/common/validators';
import { ServiceAccountMemberRole } from '#validation/member/constants';
export const serviceAccountRoleValidator = enumValidator({
    values: ServiceAccountMemberRole,
    invalidValueError: 'serviceAccount.role.invalid',
});
